import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import './plugins/bootstrap-vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSession from 'vue-session'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import * as VueGoogleMaps from "vue2-google-maps"
import VSelect from "vue-select-picker-bootstrap"

//import socketio from 'socket.io'

import './assets/custom.css'
import './assets/style.css'


import GmapCluster from 'vue2-google-maps/dist/components/cluster';

Vue.use(VueAxios, axios)
Vue.use(VueSession)
Vue.use(VueMoment, {
	moment,
});
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VSelect);

Vue.use(VueGoogleMaps, {
  load: {
   //key:"AIzaSyBfaHi28onPYaLKeX-BH-geQIlECBj21L0",
  // key:"AIzaSyB3Xfw1JwT3g3lqk8znUbCodFteO4xn_zk", 
  	//key:"AIzaSyA1OSYKi-lZ-UVm8v9tHDAS0aAHu8G3CY0", //local
	key:"AIzaSyBDIAVDv7xjBCJEpiBYVHCwG6sby08x6Cc", // live
    libraries: "places" // necessary for places input
  }
});
Vue.component('gmap-cluster', GmapCluster)

//export const SocketInstance = socketio('http://localhost:32215');

//Vue.use(VueSocketIO)
Vue.config.productionTip = false
 
/*Vue.use(new VueSocketIO({
    debug: true,
    connection: 'http://localhost:32215', //options object is Optional
    vuex: {
      store,
      actionPrefix: "SOCKET_",
      mutationPrefix: "SOCKET_"
    },
    options: { path: '/control' }
  })
);*/

moment.tz.setDefault('Asia/Kolkata');

Vue.directive('chkperm', {
  bind: function (el, binding, vnode) {
	var userinfo = vnode.context.$session.get('user_info');
	//console.log(JSON.stringify(userinfo));
	if(userinfo.role == 1){
		return 1;
	}
	var option = 'page_'+ binding.value.page;
	var perm = binding.value.perm;
	//console.log(option+" "+perm);
	if(userinfo.options[option]){
		//console.log(userinfo.options[option].indexOf(perm));
		if(userinfo.options[option].indexOf(perm) >= -1){
			el.style.display = 'block';
		}
	}
	return el.style.display = 'none';
  }
})

new Vue({
	router,
	store,
	render: h => h(App),
	data(){
		var self = this;
		return{
			access_key: '',
			app_name: '...',
			app_name_sm: 'STREET LIGHT CCMS',
			app_version: '...',
			weburl: '',
			apiurl: '',
			//weburl: 'http://103.211.218.36',
			//apiurl: 'http://103.211.218.36:3000/',
			//weburl: 'http://216.10.251.190/',
			//httpurl: 'http://119.18.55.209:3000/',
			search_sidebar: false,
			disconnection_time: 1440,
			correction_amp: 1,
			correction_volt: 80,
			reload_duration: 60*1000,
			status_options: [{ value: 0, text: 'Disabled' },{ value: 1, text: 'Enabled' }],
			state_options: [
				/* { id: 1, value: 'in-mh', text: 'Maharashtra' }, */
				{ id: 1, value: 'in-bmc', text: 'Rajasthan' },
				/*{ id: 1, value: 'in-up', text: 'Uttar Pradesh' },
				 { id: 3, value: 'in-hr', text: 'Haryana' },
				{ id: 4, value: 'in-rj', text: 'Rajasthan' },
				{ id: 5, value: 'in-uk', text: 'Uttarakhand' },
				{ id: 6, value: 'in-dl', text: 'Delhi' },
				{ id: 7, value: 'in-rh', text: 'Rachi' } */
			],
			page_zones_perm: 'page_zones',
			page_zones_perm_enabled: 'enabled',
			page_zones_perm_view: 'view',
			page_zones_perm_edit: 'edit',
			page_zones_perm_delete: 'delete',
			page: [self.page_zones_perm],
			page_zones_perm_options: [self.page_zones_perm],
			page_perm_options: [{ value: 'enabled', text: 'Enabled' },{ value: 'view', text: 'View' },{ value: 'add', text: 'Add' },{ value: 'edit', text: 'Edit' },{ value: 'delete', text: 'Delete' }],
			page_report_perm_options: [{ value: 'enabled', text: 'Enabled' },{ value: 'view', text: 'View' },{ value: 'export', text: 'Export' }],
			page_perm_masterdevices_options: [{ value: 'enabled', text: 'Enabled' },{ value: 'view', text: 'View' },{ value: 'sms', text: 'SMS' },{ value: 'replace', text: 'Replace' },{ value: 'edit', text: 'Edit' },{ value: 'delete', text: 'Delete' },{ value: 'export', text: 'Export' }],
			ulb_location:{
				2:{value:1, name:'Bharatpur', lat:27.2163, lng: 77.5017 },
				//2:{value:2, name:'Kanpur', lat:26.4499, lng: 80.3319 },
				/* 3:{value:3, name:'Aligarh',lat:27.8974, lng: 78.0880 },
				4:{value:4, name:'Deoria', lat:26.5024, lng: 83.7791 },
				5:{value:5, name:'Lucknow',lat:26.8467, lng: 80.9462 },
				6:{value:5, name:'Gorakhpur',lat:26.7606, lng: 83.3732 },
				8:{value:5, name:'Lakhimpur',lat:27.9462, lng: 80.7787 },
				9:{value:5, name:'Meerut',lat:28.9845, lng:77.7064 },
				10:{value:5, name:'Raebareli',lat:26.2145, lng:81.2528 },	
				12:{value:5, name:'Mathura',lat:27.4924, lng:77.6737 },
				13:{value:5, name:'Moradabad',lat:28.8386, lng:78.7733 },
				14:{value:5, name:'Firozabad',lat:27.1592, lng:78.3957 },
				15:{value:5, name:'Jhansi',lat:25.4484, lng:78.5685 } */
			},
			wattslight: [20,35,45,60,70,90,110,120,140,150,160,180,190,200],
				
		} 
	},
	mounted(){
		var self = this;
		self.records = [];
	},
	beforeMount: function () {
		//console.log(this.$route.fullPath.indexOf("exports"));
		if(this.$route.fullPath.indexOf("exports") < 0){
			//console.log(">>>>>>> BEFORE MOUNT >>>>>> "+this.$session.get('access_key'));
			if(this.$session.get('access_key') == '' || this.$session.get('access_key') == undefined || this.$session.get('access_key') == null){
				this.$session.destroy();
				this.$router.push('/');
			}
		}
	},
	methods: {
		is_logged_in(){
			//console.log(this.$session.get('access_key'));

			if(this.$session.get('access_key') == '' || this.$session.get('access_key') == undefined || this.$session.get('access_key') == null){
				this.$session.destroy();
				this.$router.push('/');
				return 1;
			}else{
				return 0;
			}
		},
		tofixed(value, param){
			return (value).toFixed(param);
		},
		getDashboardLink(){
			var userinfo = this.$session.get('user_info');
			if(userinfo.permissions.dashboard_link != '' && userinfo.permissions.dashboard_link != undefined){
				return userinfo.permissions.dashboard_link;
			}else{
				return '/dashboard';
			}
		},
		chkperm(option,perm){
			var userinfo = this.$session.get('user_info');
			if(userinfo.role == 1 || userinfo.role == '1'){
				return 1;
			}
			var options = userinfo.options;
			if(options[option]){
				if(options[option].indexOf(perm) > -1){
					return 1;
				}
			}
			return 0;
		},
		forceLogout(msg){
			var self = this;
			var userinfo = this.$session.get('user_info');
			if(userinfo.permissions.multi_login <= 0 || userinfo.permissions.multi_login == '0'){
				this.$bvModal.msgBoxOk(msg, {
					title: 'Security Issue',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'danger',
					okTitle: 'Logout',
					okOnly: true,
					footerClass: 'p-2',
					backdrop: 'static',
					hideHeaderClose: true,
					centered: true
				})
				.then(value => {
					if(value == true){
						//self.$session.destroy();
						self.$session.remove('access_key');
						self.$session.remove('user_info');
						self.$router.push('/')
					}
				})
				.catch(err => {
					// An error occurred
					alert(err);
					//console.log(err);
				})
			}
		},
		showMessage(title, msg, okTitle, callback=''){
			this.$bvModal.msgBoxOk(msg, {
				title: title,
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: okTitle,
				okOnly: true,
				footerClass: 'p-2',
				backdrop: 'static',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					if(callback != ''){
						callback();
					}
				}
			})
			.catch(err => {
				// An error occurred
				alert(err);
				//console.log(err);
			})
		}
	}
}).$mount('#app')
